// NOTE: Please format dates like YYYY-MM-DD
export const singVideos = [
    {
        name: "SophFrosh Flow | SING! 2016",
        date: "2016-03-12",
        videoLink: "https://www.youtube.com/embed/jMyaFOPHqmI",
    },
    {
        name: "Senior Flow | SING! 2018",
        date: "2018-05-21",
        videoLink: "https://www.youtube.com/embed/TostEUy6pf8",
    },
    {
        name: "SophFrosh Flow | SING! 2019",
        date: "2019-03-17",
        videoLink: "https://www.youtube.com/embed/yECyozRVp0c",
    },
    {
        name: "Senior Flow | SING! 2020",
        date: "2020-03-07",
        videoLink: "https://www.youtube.com/embed/dYZIYVs7IUg?start=2877",
    },
    {
        name: "Senior Flow | SING! 2019",
        date: "2020-03-07",
        videoLink: "https://www.youtube.com/embed/axA2Z1uvjLc?start=3471",
    },
    {
        name: "Senior Flow | SING! 2021",
        date: "2021-07-13",
        videoLink: "https://www.youtube.com/embed/7IT1sMiZHYs",
    },
    {
        name: "Junior Flow | SING! 2021",
        date: "2021-07-13",
        videoLink: "https://www.youtube.com/embed/IRlih29yumM",
    },
    {
        name: "SophFrosh Flow | SING! 2021",
        date: "2021-07-13",
        videoLink: "https://www.youtube.com/embed/s-OzmPEvrjw",
    },
    {
        name: "Senior Flow | Wide View | SING! 2022",
        date: "2022-03-20",
        videoLink: "https://www.youtube.com/embed/XwZ3T2_fAME",
    },
    {
        name: "Senior Flow | Stabilizer View | SING! 2022",
        date: "2022-03-20",
        videoLink: "https://www.youtube.com/embed/UmhM3lyfTu8",
    },
    {
        name: "Junior Flow | Wide View | SING! 2022",
        date: "2022-03-20",
        videoLink: "https://www.youtube.com/embed/5G9PKX1ktWc",
    },
    {
        name: "Junior Flow | Stabilizer View | SING! 2022",
        date: "2022-03-20",
        videoLink: "https://www.youtube.com/embed/J1U0xVId7Ek",
    },
    {
        name: "SophFrosh Flow | Wide View | SING! 2022",
        date: "2022-03-20",
        videoLink: "https://www.youtube.com/embed/hqmJbN4a0Lc",
    },
    {
        name: "SophFrosh Flow | Stabilizer View | SING! 2022",
        date: "2022-03-20",
        videoLink: "https://www.youtube.com/embed/YunYVsRfuJQ",
    },
    {
        name: "Senior Flow | SING! 2023",
        date: "2023-03-20",
        videoLink: "https://www.youtube.com/embed/5HXsV3elFfE",
    },
    {
        name: "Junior Flow | Teeth | SING! 2023",
        date: "2023-03-20",
        videoLink: "https://www.youtube.com/embed/ILk8XwnUa3s",
    },
    {
        name: "Junior Flow | Savage | SING! 2023",
        date: "2023-03-20",
        videoLink: "https://www.youtube.com/embed/ramdp6wZEbY",
    },
    {
        name: "SophFrosh Flow | SING! 2023",
        date: "2023-03-20",
        videoLink: "https://www.youtube.com/embed/Bhu5tXJBYes",
    },
    {
        name: "Senior Flow | SING! 2024",
        date: "2024-03-20",
        videoLink: "https://www.youtube.com/embed/FYGQrWuKJ5E",
    },
    {
        name: "Junior Flow | SING! 2024",
        date: "2024-03-20",
        videoLink: "https://www.youtube.com/embed/b4-b_rJC0qc",
    },
    {
        name: "SophFrosh Flow | SING! 2024",
        date: "2024-03-20",
        videoLink: "https://www.youtube.com/embed/-I83ABv9o7E",
    },
    


    
]
